// original code from  ACEPayments/src/utils/cookieHelper.js                                                                                                                                      898/898               100%
const ClubCodeURLMap: { [club: string]: string } = {
  '004': 'calif',
  '252': 'texas',
  '601': 'newmexico',
  '018': 'hawaii',
  '036': 'northernnewengland',
  '001': 'alabama',
  '215': 'eastcentral',
  '258': 'tidewater',
  '065': 'autoclubmo',
};

export class URLHelper {
  static getMvcEnv(clubCode: string) {
    const clubName = ClubCodeURLMap[clubCode] || 'calif';
    return `apps.${clubName}`;
  }

  static getMyAccountURL(clubCode: string) {
    const clubName = ClubCodeURLMap[clubCode] || 'calif';
    return `https://apps2.${clubName}.aaa.com/aceapps/myaccount`;
  }
}
